import http from './axiosConfig' //引入基础配置
import { newBaseUrl as baseUrl } from "./api";
let getData = {}
 // 添加上传资料
  getData.DFPfiles= (data)=>{ 
    return http.post(baseUrl+"/download/files/",data)
  }
  // 查看全部上传列表
  getData.DFGAllfiles= (data)=>{ 
    return http.get(baseUrl+"/download/files/",{ params:data })
  }
  // 获取单个
  getData.DFGfile= (pk,data)=>{ 
    return http.get(baseUrl+"/download/file/"+pk+"/",{ params:data })
  }
  //修改上传资料
  getData.DFPAfile= (pk,data)=>{
    return http.patch(baseUrl+"/download/file/"+pk+"/",data)
  }
  // 删除上传资料
  getData.DFDelfile= (pk,data)=>{
    return http.delete(baseUrl+"/download/file/"+pk+"/",data)
  }
 // 下载文件
 getData.DFPdown= (data,Progresscall)=>{ 
  // return http.post(baseUrl+"/download/down/",data)
  return http({
    method: 'post',
    url: baseUrl+"/download/down/", // 请求地址
    data: data, // 参数
    responseType: 'blob', // 表明返回服务器返回的数据类型
    onDownloadProgress(progress) {

      // const step = Math.round(progress.loaded / progress.total * 100)
      // console.log(step + '%')
      // console.log(progress.loaded,progress.total,step,progress); 
      Progresscall(progress.loaded)
    }
  })
}
export default getData


// WEBPACK FOOTER //
// ./src/common/DownloadApi.js